import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { DataStatus, Message } from 'src/core/engine';

import { CartAddConfigParams, CartAddSimpleParams, CartMsg } from '../cart.actions';
import { AppendState } from '../cart.reducer';

interface CartAddConfigApi {
    status: DataStatus;
    pending: boolean;
    messages: Message[];
    addConfig(params: CartAddConfigParams): void;
    addSimple(params: CartAddSimpleParams): void;
    clearMessages(): void;
}

const selector = (s: AppendState) => {
    const { messages, status } = s.cart;
    return {
        messages,
        status,
    };
};

export function useCartAdd(): CartAddConfigApi {
    const dispatch = useDispatch();
    const { messages, status } = useSelector(selector, shallowEqual);
    const pending = status === DataStatus.Pending || status === DataStatus.Idle;
    const addConfig = useCallback(
        (params: CartAddConfigParams) => {
            dispatch(CartMsg('Cart.Add.Config', params));
        },
        [dispatch],
    );
    const addSimple = useCallback(
        (params: CartAddSimpleParams) => {
            dispatch(CartMsg('Cart.Add.Simple', params));
        },
        [dispatch],
    );
    const clearMessages = useCallback(() => {
        dispatch(CartMsg('Cart.ClearMessages'));
    }, [dispatch]);
    return { status, pending, addConfig, addSimple, messages, clearMessages };
}
